import { ButtonSecondary } from "../../screens/login.screen/login.styled";
import { Label } from "../../screens/complaint/Complaint.styled";
import { TabContainer } from "./Social.styled";
import General from '../../stores/GeneralStore'
import { useRef, useState, useEffect } from "react";
import moment from "moment";
import { observer } from "mobx-react";

import '../../screens/complaint/Complaint.styled'

//remove any !!!
const SocialDetails = observer(({ socialCase, onNext }: { socialCase: any, onNext: any }) => {


  // for setting Family Members, Social Status
  type socialDetailsInfo = {
    familyMember: number | string;
    socialStatus: string;
    caseDetailsComments: string;
  };
  const [socialDetailsInfo, setsocialDetailsInfo] = useState<socialDetailsInfo>({
    familyMember: 1,
    socialStatus: "SENIOR",
    caseDetailsComments: ""
  });


  function updateSocialDetailsInfo(event: React.ChangeEvent<HTMLSelectElement>) {
    setsocialDetailsInfo({
      ...socialDetailsInfo,
      [event.target.name]: event.target.value
    });


  }
  // for setting text area field (Case Details)
  const [comments, setComments] = useState('');
  function handleCommentsChange(event: React.ChangeEvent<HTMLTextAreaElement>) {
    setsocialDetailsInfo({
      ...socialDetailsInfo,
      caseDetailsComments: event.target.value
    });
  }

  const handleNext = () => {
    onNext(socialDetailsInfo)
  }
  const ColorAss = General?.ColorAss;
  const contrast = General?.contrast;

  useEffect(() => {
    console.log('Changed 1: ', ColorAss);
  }, [ColorAss])
  return (
    <>
      <TabContainer

        style={{
          marginTop: "40px",
          flexDirection: 'column',
          display: General?.isLargeScreen ? "" : 'flex',
        }}>
        <Label style={{
          color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
          fontFamily: "Segoe UI",
          fontStyle: "normal",
          fontWeight: "700",
          lineHeight: "16px",
          fontSize: `${General.accessibility.fontSize}rem`,
          gap: "0.5rem",
          width: General?.isLargeScreen ? '' : '98%'
        }}>

          {General?.codeLabels["cm_noccustomername"]?.label !== undefined ? General?.codeLabels["cm_noccustomername"]?.label : "Customer Name"}

          <input style={{ background: contrast?.contrastBackground ? contrast?.contrastColor : "white", paddingRight: '12px', color: contrast?.contrastBackground ? contrast?.contrastBackground : ColorAss }}
            type="text" defaultValue={socialCase.primaryName} disabled  /> {/* if current lanf ar ==> alternativeName*/}
        </Label>
        <Label style={{
          color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
          fontFamily: "Segoe UI",
          fontStyle: "normal",
          fontWeight: "700",
          lineHeight: "16px",
          fontSize: `${General.accessibility.fontSize}rem`,
          gap: "0.5rem",
          width: General?.isLargeScreen ? '' : '98%'
        }}>

          {General?.codeLabels["cm_enterparcel"]?.label !== undefined ? General?.codeLabels["cm_enterparcel"]?.label : "Parcel Number"}

          <input style={{ background: contrast?.contrastBackground ? contrast?.contrastColor :"white", paddingRight: '12px', color:contrast?.contrastBackground?contrast?.contrastBackground:ColorAss }} type="text" defaultValue={socialCase.cmParcelId} disabled />
        </Label>
        <Label style={{
          color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
          fontFamily: "Segoe UI",
          fontStyle: "normal",
          fontWeight: "700",
          lineHeight: "16px",
          fontSize: `${General.accessibility.fontSize}rem`,
          gap: "0.5rem",
          width: General?.isLargeScreen ? '' : '98%'
        }}>
          {General?.codeLabels["cm_emirate_id"]?.label ? General?.codeLabels["cm_emirate_id"]?.label : "Emirates ID Number"}
          <input style={{ background: contrast?.contrastBackground ? contrast?.contrastColor :"white", paddingRight: '12px', color:contrast?.contrastBackground?contrast?.contrastBackground:ColorAss }} type="text" defaultValue={socialCase.cmEmiratesId} disabled />
        </Label>
        <Label style={{
          color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
          fontFamily: "Segoe UI",
          fontStyle: "normal",
          fontWeight: "700",
          lineHeight: "16px",
          fontSize: `${General.accessibility.fontSize}rem`,
          gap: "0.5rem",
          width: General?.isLargeScreen ? '' : '98%'
        }}>

          {General?.codeLabels["cm_tarifftype"]?.label !== undefined ? General?.codeLabels["cm_tarifftype"]?.label : "Tariff Type"}

          <input style={{ background: contrast?.contrastBackground ? contrast?.contrastColor :"white", paddingRight: '12px', color:contrast?.contrastBackground?contrast?.contrastBackground:ColorAss }}
            type="text"
            defaultValue='Connection Fees'
            disabled
          />
        </Label>
        <Label style={{
          color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
          fontFamily: "Segoe UI",
          fontStyle: "normal",
          fontWeight: "700",
          lineHeight: "16px",
          fontSize: `${General.accessibility.fontSize}rem`,
          gap: "0.5rem",
          width: General?.isLargeScreen ? '' : '98%'
        }}>

          {General?.codeLabels["cm_total_due_amount"]?.label !== undefined ? General?.codeLabels["cm_total_due_amount"]?.label : "Total Due"}

          <input style={{ background: contrast?.contrastBackground ? contrast?.contrastColor :"white", paddingRight: '12px', color:contrast?.contrastBackground?contrast?.contrastBackground:ColorAss }} type="number" defaultValue={socialCase.cmConnectorDue} disabled />
        </Label>
        <Label style={{
          color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
          fontFamily: "Segoe UI",
          fontStyle: "normal",
          fontWeight: "700",
          lineHeight: "16px",
          gap: "0.5rem",
          width: General?.isLargeScreen ? '' : '98%',
          fontSize: `${General.accessibility.fontSize}rem`,

        }}>

          {General?.codeLabels["cm_date"]?.label !== undefined ? General?.codeLabels["cm_date"]?.label : "Date"}

            <input style={{ background: contrast?.contrastBackground ? contrast?.contrastColor :"white", paddingRight: '12px', color:contrast?.contrastBackground?contrast?.contrastBackground:ColorAss }} type="text" defaultValue={moment().format("DD MMM YYYY")} disabled />
        </Label>
        <Label style={{
          color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
          fontFamily: "Segoe UI",
          fontStyle: "normal",
          fontWeight: "700",
          lineHeight: "20px",
          gap: "0.5rem",
          width: General?.isLargeScreen ? '' : '98%',
          fontSize: `${General.accessibility.fontSize}rem`,

        }}>

          {General?.codeLabels["cm_familymembers"]?.label !== undefined ? General?.codeLabels["cm_familymembers"]?.label : "Family Members"}

          <select  style={{ paddingRight: '12px', background: contrast?.contrastBackground ? contrast?.contrastColor :'#e5eff2', color:contrast?.contrastBackground?contrast?.contrastBackground:ColorAss }} name="familyMember" onChange={updateSocialDetailsInfo}>
            <option style={{ fontSize: `${General.accessibility.fontSize}rem`,color:contrast?.contrastBackground?contrast?.contrastBackground:ColorAss }} >{General?.codeLabels["cm_mob_select"]?.label !== undefined ? General?.codeLabels["cm_mob_select"]?.label : "Select"}</option>
            <option style={{ fontSize: `${General.accessibility.fontSize}rem`,color:contrast?.contrastBackground?contrast?.contrastBackground:ColorAss,padding:"1rem" }} value={1}>1</option>
            <option style={{ fontSize: `${General.accessibility.fontSize}rem`,color:contrast?.contrastBackground?contrast?.contrastBackground:ColorAss,padding:"1rem" }} value={2}>2</option>
            <option style={{ fontSize: `${General.accessibility.fontSize}rem`,color:contrast?.contrastBackground?contrast?.contrastBackground:ColorAss,padding:"1rem" }} value={3}>3</option>
            <option style={{ fontSize: `${General.accessibility.fontSize}rem`,color:contrast?.contrastBackground?contrast?.contrastBackground:ColorAss,padding:"1rem" }} value={4}>4</option>
            <option style={{ fontSize: `${General.accessibility.fontSize}rem`,color:contrast?.contrastBackground?contrast?.contrastBackground:ColorAss,padding:"1rem" }} value={5}>+5</option>
          </select>
        </Label>
        <Label style={{
          color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
          fontFamily: "Segoe UI",
          fontStyle: "normal",
          fontWeight: "700",
          lineHeight: "16px",
          gap: "0.5rem",
          width: General?.isLargeScreen ? '' : '98%',
          fontSize: `${General.accessibility.fontSize}rem`,

        }}>

          {General?.codeLabels["Social Status"]?.label !== undefined ? General?.codeLabels["Social Status"]?.label : "Social Status"}

          <select  style={{ paddingRight: '12px', background: contrast?.contrastBackground ? contrast?.contrastColor :'#e5eff2', color:contrast?.contrastBackground?contrast?.contrastBackground:ColorAss }} name="socialStatus" onChange={updateSocialDetailsInfo} >
            <option style={{ fontSize: `${General.accessibility.fontSize}rem`,color:contrast?.contrastBackground?contrast?.contrastBackground:ColorAss }} >{General?.codeLabels["cm_mob_select"]?.label !== undefined ? General?.codeLabels["cm_mob_select"]?.label : "Select"}</option>
            <option style={{ fontSize: `${General.accessibility.fontSize}rem`,color:contrast?.contrastBackground?contrast?.contrastBackground:ColorAss }} value="SENIOR">{General?.codeLabels["cm_senior_citizen"]?.label ? General?.codeLabels["cm_senior_citizen"]?.label : "Senior Citizens"}</option>
            <option style={{ fontSize: `${General.accessibility.fontSize}rem`,color:contrast?.contrastBackground?contrast?.contrastBackground:ColorAss }} value="DETERMINATION">{General?.codeLabels["cm_determ"]?.label ? General?.codeLabels["cm_determ"]?.label : "People Of Determination"}</option>
            <option style={{ fontSize: `${General.accessibility.fontSize}rem`,color:contrast?.contrastBackground?contrast?.contrastBackground:ColorAss }} value="WIDOW">{General?.codeLabels["cm_widow"]?.label ? General?.codeLabels["cm_widow"]?.label : "Widows"}</option>
            <option style={{ fontSize: `${General.accessibility.fontSize}rem`,color:contrast?.contrastBackground?contrast?.contrastBackground:ColorAss }} value="DIVORCED">{General?.codeLabels["cm_divorced"]?.label ? General?.codeLabels["cm_divorced"]?.label : "Divorced Women"}</option>
            <option style={{ fontSize: `${General.accessibility.fontSize}rem`,color:contrast?.contrastBackground?contrast?.contrastBackground:ColorAss }} value="ABANDONED">{General?.codeLabels["cm_abondeone"]?.label ? General?.codeLabels["cm_abondeone"]?.label : "Abandoned"}</option>
            <option style={{ fontSize: `${General.accessibility.fontSize}rem`,color:contrast?.contrastBackground?contrast?.contrastBackground:ColorAss }} value="RETIRED">{General?.codeLabels["cm_retired"]?.label ? General?.codeLabels["cm_retired"]?.label : "Retired Persons"}</option>
            <option style={{ fontSize: `${General.accessibility.fontSize}rem`,color:contrast?.contrastBackground?contrast?.contrastBackground:ColorAss }} value="LOW INCOME">{General?.codeLabels["cm_lowIncome"]?.label ? General?.codeLabels["cm_lowIncome"]?.label : "Low-income Employees"}</option>
            <option style={{ fontSize: `${General.accessibility.fontSize}rem`,color:contrast?.contrastBackground?contrast?.contrastBackground:ColorAss }} value="RECIPIENT">{General?.codeLabels["cm_welfare"]?.label ? General?.codeLabels["cm_welfare"]?.label : "Recipients of Social Welfare"}</option>
            <option style={{ fontSize: `${General.accessibility.fontSize}rem`,color:contrast?.contrastBackground?contrast?.contrastBackground:ColorAss }} value="DEBTORS">{General?.codeLabels["cm_doctor"]?.label ? General?.codeLabels["cm_doctor"]?.label : "Housing Debtor"}</option>
            <option style={{ fontSize: `${General.accessibility.fontSize}rem`,color:contrast?.contrastBackground?contrast?.contrastBackground:ColorAss }} value="ORPHANS">{General?.codeLabels["cm_orphan"]?.label ? General?.codeLabels["cm_orphan"]?.label : "Orphans"}</option>
          </select>
        </Label>
        <Label style={{
          color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
          gridColumn: "1 / span 2", fontFamily: "Segoe UI",
          fontStyle: "normal",
          fontWeight: "700",
          lineHeight: "16px",
          gap: "0.5rem",
          width: General?.isLargeScreen ? '' : '98%',
          fontSize: `${General.accessibility.fontSize}rem`,
        }}>
          {General?.codeLabels['cm_sc_justification']?.label ? General?.codeLabels['cm_sc_justification']?.label : "Case Details"}{" "}
          <textarea
            placeholder={General?.codeLabels["cm_comment_here"]?.label ? General?.codeLabels["cm_comment_here"]?.label : "Comments go here"}
            value={socialDetailsInfo.caseDetailsComments} onChange={handleCommentsChange}
            style={{ background: contrast?.contrastBackground ? contrast?.contrastColor :'#e5eff2', color:contrast?.contrastBackground?contrast?.contrastBackground:ColorAss }}
            rows={4}
          ></textarea>
        </Label>
        <hr style={{ width: "100%", gridColumn: "1 / span 2", background: contrast.contrastColor? contrast.contrastColor:"#101E8E", mixBlendMode: "normal", opacity: "0.2", fontSize: `${General.accessibility.fontSize}rem` }} />
        <ButtonSecondary  onClick={handleNext} style={{ width: General?.isLargeScreen ? "168px" : "98%", fontFamily: "Segoe UI", fontStyle: "normal", fontWeight: "700", fontSize: `${General.accessibility.fontSize}rem`, lineHeight: "16px", textAlign: "center", textTransform: "uppercase", color: contrast?.contrastBackground ? contrast?.contrastBackground : "#fff", background: contrast?.contrastColor ? contrast?.contrastColor : ColorAss, }}>
          {General?.codeLabels["cm_next"]?.label !== undefined ? General?.codeLabels["cm_next"]?.label : "NEXT"}
        </ButtonSecondary>
      </TabContainer>
    </>
  );
});

export default SocialDetails;
